'use client';

import { useDialog } from '@musinsa/mds-ui';
import { useDeviceInfo } from '@musinsa/packages-device-detection';
import type {
  SubmitJoinApplicationServiceRequest,
  SubmitJoinApplicationServiceResponse,
} from '@musinsa/services-curator';
import { submitJoinApplicationService } from '@musinsa/services-curator';
import { useMutation } from '@tanstack/react-query';
import { getPaths, useCuratorBroadcastPublisher } from '../../common';
import { useNavigate } from '../../common/hooks/useNavigate';
import { curatorQueries } from '../../query-factory';

// API 에러 타입 정의
interface ApiError extends Error {
  data?: {
    meta?: {
      message?: string;
    };
  };
}

export const useSubmitJoinApplication = () => {
  const dialog = useDialog();
  const { navigateReplace } = useNavigate();
  const { triggerQuerySync } = useCuratorBroadcastPublisher();
  const { service } = useDeviceInfo();
  const paths = getPaths(service);

  return useMutation<
    SubmitJoinApplicationServiceResponse,
    ApiError,
    SubmitJoinApplicationServiceRequest
  >({
    mutationFn: (data: SubmitJoinApplicationServiceRequest) => submitJoinApplicationService(data),
    onSuccess: () => {
      triggerQuerySync({
        queryKeys: [curatorQueries.join.checkJoinEligibility({}).queryKey],
      });

      dialog.open({
        title:
          '신청이 완료되었습니다. 가입 심사 후 결과는 카카오톡 알림톡으로 안내드릴 예정입니다.',
        confirmButtonText: '확인',
        onConfirm: () => {
          navigateReplace(paths.intro());
        },
      });
    },
  });
};
